/* ============================================
   THE VITAMIN PATCH — shopify-search.js
   Predictive Search via Storefront API
   ============================================
   REQUIRES: shopify-config.js loaded first

   WHAT THIS DOES:
   - Attaches live search to all .search-input elements
   - Shows product dropdown as user types
   - Enter key goes to search results page
   - Styled to match TVP orange/dark design
   ============================================ */

(function() {
  'use strict';

  var SEARCH_QUERY = '\
    query predictiveSearch($query: String!) {\
      predictiveSearch(query: $query, types: [PRODUCT, COLLECTION], limitScope: EACH) {\
        products {\
          id handle title\
          priceRange { minVariantPrice { amount } }\
          featuredImage { url }\
          variants(first: 1) { edges { node { id availableForSale } } }\
        }\
        collections { id handle title }\
      }\
    }';

  function injectStyles() {
    if (document.getElementById('tvpSS')) return;
    var s = document.createElement('style');
    s.id = 'tvpSS';
    s.textContent = [
      '.tvp-sw{position:relative}',
      '.tvp-sd{position:absolute;top:calc(100% + 8px);left:0;width:380px;max-width:90vw;background:#fff;border:1px solid #e5e5e5;border-radius:8px;box-shadow:0 8px 32px rgba(0,0,0,.14);z-index:9000;display:none;overflow:hidden}',
      '.tvp-sd.open{display:block}',
      '.tvp-sl{font-family:"Bebas Neue",sans-serif;font-size:13px;letter-spacing:1.5px;color:#888;padding:12px 16px 6px;border-bottom:1px solid #f5f5f5}',
      '.tvp-sr{display:flex;align-items:center;gap:12px;padding:10px 16px;text-decoration:none;color:inherit;transition:background .15s}',
      '.tvp-sr:hover{background:#f9f9f9}',
      '.tvp-sr-img{width:48px;height:48px;object-fit:cover;border-radius:5px;flex-shrink:0;background:#f0f0f0}',
      '.tvp-sr-name{font-family:Barlow,sans-serif;font-size:13px;font-weight:600;color:#111;margin-bottom:2px}',
      '.tvp-sr-price{font-family:Barlow,sans-serif;font-size:12px;color:#f97316;font-weight:600}',
      '.tvp-sc{display:block;padding:9px 16px;font-family:Barlow,sans-serif;font-size:13px;color:#333;text-decoration:none;transition:background .15s}',
      '.tvp-sc:hover{background:#f9f9f9;color:#f97316}',
      '.tvp-sf{padding:10px 16px;border-top:1px solid #f0f0f0;text-align:center}',
      '.tvp-sf a{font-family:Barlow,sans-serif;font-size:12px;color:#f97316;font-weight:600;text-decoration:none;letter-spacing:.5px}',
      '.tvp-se{padding:20px 16px;font-family:Barlow,sans-serif;font-size:13px;color:#888;text-align:center}',
      '.tvp-sload{padding:16px;font-family:Barlow,sans-serif;font-size:13px;color:#aaa;text-align:center}'
    ].join('');
    document.head.appendChild(s);
  }

  function debounce(fn, ms) {
    var t;
    return function() {
      var a = arguments, c = this;
      clearTimeout(t);
      t = setTimeout(function() { fn.apply(c, a); }, ms);
    };
  }

  function renderResults(dropdown, data, query) {
    var products    = data.predictiveSearch.products    || [];
    var collections = data.predictiveSearch.collections || [];

    if (!products.length && !collections.length) {
      dropdown.innerHTML = '<div class="tvp-se">No results for "' + query + '"</div>';
      return;
    }

    var html = '';

    if (products.length) {
      html += '<div class="tvp-sl">PRODUCTS</div>';
      products.slice(0, 5).forEach(function(p) {
        var img   = p.featuredImage ? p.featuredImage.url : '';
        var price = TVP.formatPrice(p.priceRange.minVariantPrice.amount);
        html += '<a href="product-' + p.handle + '.html" class="tvp-sr">' +
          '<img class="tvp-sr-img" src="' + img + '" alt="' + p.title + '" />' +
          '<div><div class="tvp-sr-name">' + p.title + '</div><div class="tvp-sr-price">' + price + '</div></div>' +
        '</a>';
      });
    }

    if (collections.length) {
      html += '<div class="tvp-sl">CATEGORIES</div>';
      collections.slice(0, 3).forEach(function(c) {
        html += '<a href="catalog.html?collection=' + c.handle + '" class="tvp-sc">→ ' + c.title + '</a>';
      });
    }

    html += '<div class="tvp-sf"><a href="search.html?q=' + encodeURIComponent(query) + '">VIEW ALL RESULTS FOR "' + query.toUpperCase() + '"</a></div>';
    dropdown.innerHTML = html;
  }

  function wireInput(input) {
    var bar = input.closest('.search-bar');
    if (!bar) return;
    bar.classList.add('tvp-sw');

    var dropdown = document.createElement('div');
    dropdown.className = 'tvp-sd';
    bar.appendChild(dropdown);

    var lastQuery = '';

    var doSearch = debounce(function(q) {
      if (q.length < 2) { dropdown.classList.remove('open'); return; }
      if (q === lastQuery) return;
      lastQuery = q;
      dropdown.innerHTML = '<div class="tvp-sload">Searching...</div>';
      dropdown.classList.add('open');

      TVP.api(SEARCH_QUERY, { query: q }).then(function(data) {
        if (input.value.trim() !== q) return;
        renderResults(dropdown, data, q);
      }).catch(function() {
        dropdown.innerHTML = '<div class="tvp-se">Search unavailable. Please try again.</div>';
      });
    }, 300);

    input.addEventListener('keyup', function(e) {
      var q = input.value.trim();
      if (e.key === 'Enter' && q) {
        dropdown.classList.remove('open');
        window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product';
        return;
      }
      if (!q) { dropdown.classList.remove('open'); lastQuery = ''; return; }
      doSearch(q);
    });

    var btn = bar.querySelector('.search-btn');
    if (btn) {
      btn.addEventListener('click', function() {
        var q = input.value.trim();
        if (q) { dropdown.classList.remove('open'); window.location.href = '/search?q=' + encodeURIComponent(q) + '&type=product'; }
      });
    }

    document.addEventListener('click', function(e) {
      if (!bar.contains(e.target)) dropdown.classList.remove('open');
    });

    input.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') { dropdown.classList.remove('open'); input.blur(); }
    });
  }

  function init() {
    injectStyles();
    document.querySelectorAll('.search-input').forEach(function(input) { wireInput(input); });
  }

  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', init)
    : init();

})();
